import {
  AbstractControl,
  FormControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Utils } from './utils';

// tslint:disable-next-line: class-name
export class customValidators {
  public static get emailPattern() {
    return customValidators._emailPattern;
  }
  public static get phoneNumberPattern() {
    return customValidators._phoneNumberPattern;
  }
  public static get zipCodePattern() {
    return customValidators._zipCodePatttern;
  }
  public static get notWhiteSpacesPattern() {
    return customValidators._notWhiteSpacesPattern;
  }

  // Static definitions with generic patterns
  private static _emailPattern = Validators.pattern(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );

  private static _phoneNumberPattern = Validators.pattern(
    /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/i
  );

  private static _zipCodePatttern = Validators.pattern(/^[0-9]{2}\-[0-9]{3}$/i);

  private static _notWhiteSpacesPattern = Validators.pattern(/^\S+$/i);

  static fileMaxSize(maxSize: number): ValidatorFn {
    const validatorFn = (file: File) => {
      customValidators.readFile(file);
      if (file) {
        if (file.size > maxSize) {
          return {
            fileMaxSize: { requiredSize: maxSize, actualSize: file.size, file },
          };
        }
      }
    };
    return customValidators.fileValidation(validatorFn);
  }

  static fileFormat(listOfFormats): ValidatorFn {
    const validatorFn = (file: File) => {
      customValidators.readFile(file);
      if (file && file.name) {
        if (!listOfFormats.includes(file.name.split('.')[1])) {
          return {
            fileFormat: {
              requiredFormat: listOfFormats,
              actualFormat: file.name.split('.')[1],
              file,
            },
          };
        }
      }
    };
    return customValidators.fileValidation(validatorFn);
  }

  private static fileValidation(validatorFn: (File) => object): ValidatorFn {
    return (formControl: FormControl) => {
      if (!formControl.value) {
        return null;
      }

      const files: File[] = [];
      const isMultiple = Array.isArray(formControl.value);
      isMultiple
        ? formControl.value.forEach((file: File) => files.push(file))
        : files.push(formControl.value);

      for (const file of files) {
        return validatorFn(file);
      }

      return null;
    };
  }

  static readFile(fileEvent: any) {
    const file = fileEvent;
  }

  static dateValidator(dateFrom, dateTo): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const fromCtrl = new Date(group.get(dateFrom).value);
      const toCtrl = new Date(group.get(dateTo).value);

      if (fromCtrl.getTime() == toCtrl.getTime()) {
        return { sameDates: true };
      }

      if (fromCtrl.getTime() > toCtrl.getTime()) {
        return { startDateBigger: true };
      }
    };
  }

  static timeValidator(timeFrom, timeTo): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      let start: string = group.get(timeFrom).value;
      let end: string = group.get(timeTo).value;

      if (start && end) {
        let startArray = start.split(':');
        let endArray = end.split(':');

        if (
          `${endArray[0].padStart(2, '0')}:${endArray[1].padStart(2, '0')}` <=
          `${startArray[0].padStart(2, '0')}:${startArray[1].padStart(2, '0')}`
        ) {
          return { startTimeBigger: true };
        }
        return null;
      }
    };
  }
  /**
   * Sprawdza czy input nie jest wypełniony samymi spacjami
   * @static
   * @return {*}  {ValidatorFn}
   * @memberof customValidators
   */
  public static trimValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val: string = control.value;
      if (val) {
        return !val.trim().length ? { onlySpaces: true } : null;
      }
    };
  }
  /**
   * Sprawdza czy długość wyrażenia jest większa niż założona maksymalna długość.
   * Pomija białe znaki.
   * @param maxLength Maksymalna długość ciągu znaków
   */
  public static maxLengthWithoutWhiteSpacesValidator(
    maxLength: number
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const val: string = control.value;
      if (val) {
        return val.replace(/\s/g, '').length > maxLength
          ? {
              maxLengthWithoutSpaces: {
                requiredLength: maxLength,
              },
            }
          : null;
      }
    };
  }

  public static inRange(minValue: number, maxValue: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const val: number = Number(control.value);
      if (!val && val !== 0) {
        return { notNumber: true };
      }

      if (val < minValue || val > maxValue) {
        return { notInRange: true };
      }

      return null;
    };
  }

  public static isFloat() {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value % 1 !== 0) {
        return { isFloat: true };
      }
      return null;
    };
  }
  public static samePasswords(newPassword: string, newPasswordAgain: string) {
    return (group: AbstractControl): ValidationErrors | null => {
      let pass = group.get(newPassword).value;
      let passAgain = group.get(newPasswordAgain).value;
      if (pass !== passAgain) {
        return { notSamePasswords: true };
      }
      return null;
    };
  }
  /**
   * Walidator utworzony dla edytora tinyMCE.
   * Powstał, ponieważ standardowe walidatory nie działały poprawnie.
   *
   * @returns Zwraca błąd jeżeli edytor jest pusty, lub jest wypelniony białymi znakami.
   */
  public static tinyValidator(): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
      return Utils.checkTiny(control.value) ? null : { tinyInvalid: true };
    };
  }
}
